export enum ViewMode {
	notSet = 'not-set',
	customerPresentation = 'customer-presentation',
	fullScreen = 'fullscreen',
	blueprintTechnician = 'blueprint-technician'
}
